"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPermissions = void 0;
var UserPermissions;
(function (UserPermissions) {
    UserPermissions["userAdmin"] = "USER_ADMIN";
    UserPermissions["orgAdmin"] = "ORG_ADMIN";
    UserPermissions["strainView"] = "STRAIN_VIEW";
    UserPermissions["strainEdit"] = "STRAIN_EDIT";
    UserPermissions["generalEdit"] = "GENERAL_EDIT";
})(UserPermissions = exports.UserPermissions || (exports.UserPermissions = {}));
//# sourceMappingURL=user.js.map